(function(){
  if(window.__SM_ART_ZOOM_V4)return;window.__SM_ART_ZOOM_V4=true;

  var box,stage,img,scale=1,tx=0,ty=0,startX=0,startY=0,startTx=0,startTy=0;
  var pointers=new Map(),pinchStart=0,pinchScale=1,dragging=false,moved=false,lastTap=0;
  var touchPinchStart=0,touchPinchScale=1,touchCenter=null,touchDragging=false,touchStartX=0,touchStartY=0,touchStartTx=0,touchStartTy=0;

  function graffiti(el){return !!(el&&el.closest&&el.closest('.smg5-frame,.smg5-card-img,.smg5-zoom-host'))}
  function eligible(el){
    if(!el||el.tagName!=='IMG')return false;
    if(graffiti(el))return true;
    if(!el.closest('#container'))return false;
    if(el.closest('header,.sm-site-chrome,footer,#nav-shopping-cart-dialog,.sm-cart-wrap,.cart-page,.sm-mini-cart-list,.newsletter-bar,.site-overlay'))return false;
    if(el.classList.contains('cart__image'))return false;
    if(el.closest('.product-thumb-img-wrap,#product-gallery,.template-product,.rte-page,.sm-home-v2-shell'))return true;
    var r=el.getBoundingClientRect();return r.width>=220&&r.height>=180;
  }
  function protect(el){if(!eligible(el))return;el.classList.add('sm-art-protected');el.draggable=false;el.setAttribute('draggable','false')}
  function srcFor(el){
    var s=el.currentSrc||el.getAttribute('data-src')||el.src||'';
    if(graffiti(el))s=s.replace(/([?&])width=\d+/,'$1width=2400');
    return s;
  }
  function clamp(){scale=Math.max(1,Math.min(5,scale));if(scale===1){tx=0;ty=0}}
  function draw(){clamp();img.style.transform='translate3d('+tx+'px,'+ty+'px,0) scale('+scale+')';if(box)box.dataset.zoomed=scale>1?'1':'0'}
  function setScale(next,cx,cy){
    var old=scale;
    scale=Math.max(1,Math.min(5,next));
    if(scale===1){tx=0;ty=0}
    else if(typeof cx==='number'&&typeof cy==='number'&&stage){
      var r=stage.getBoundingClientRect();
      var dx=cx-(r.left+r.width/2),dy=cy-(r.top+r.height/2);
      var ratio=scale/old;
      tx=(tx-dx)*ratio+dx;
      ty=(ty-dy)*ratio+dy;
    }
    draw();
  }
  function reset(){scale=1;tx=0;ty=0;draw()}
  function touchDistance(touches){
    if(!touches||touches.length<2)return 0;
    var dx=touches[0].clientX-touches[1].clientX,dy=touches[0].clientY-touches[1].clientY;
    return Math.hypot(dx,dy);
  }
  function touchMidpoint(touches){
    if(!touches||touches.length<2)return null;
    return {x:(touches[0].clientX+touches[1].clientX)/2,y:(touches[0].clientY+touches[1].clientY)/2};
  }
  function onTouchStart(e){
    if(!box||!box.classList.contains('is-open'))return;
    if(e.touches.length===2){
      e.preventDefault();
      touchPinchStart=touchDistance(e.touches);
      touchPinchScale=scale;
      touchCenter=touchMidpoint(e.touches);
      touchDragging=false;
      moved=true;
    }else if(e.touches.length===1&&scale>1){
      e.preventDefault();
      touchDragging=true;
      touchStartX=e.touches[0].clientX;
      touchStartY=e.touches[0].clientY;
      touchStartTx=tx;
      touchStartTy=ty;
      box.classList.add('is-dragging');
    }
  }
  function onTouchMove(e){
    if(!box||!box.classList.contains('is-open'))return;
    if(e.touches.length===2&&touchPinchStart){
      e.preventDefault();
      var d=touchDistance(e.touches),m=touchMidpoint(e.touches)||touchCenter;
      setScale(touchPinchScale*(d/touchPinchStart),m&&m.x,m&&m.y);
      moved=true;
      return;
    }
    if(e.touches.length===1&&touchDragging&&scale>1){
      e.preventDefault();
      var dx=e.touches[0].clientX-touchStartX,dy=e.touches[0].clientY-touchStartY;
      if(Math.abs(dx)>2||Math.abs(dy)>2)moved=true;
      tx=touchStartTx+dx;ty=touchStartTy+dy;draw();
    }
  }
  function onTouchEnd(e){
    if(!box||!box.classList.contains('is-open'))return;
    if(e.touches.length<2){touchPinchStart=0;touchPinchScale=scale;touchCenter=null}
    if(e.touches.length===0){
      touchDragging=false;
      box.classList.remove('is-dragging');
      setTimeout(function(){moved=false},80);
    }
  }
  function build(){
    if(box)return;
    box=document.createElement('div');box.className='sm-art-lightbox';box.setAttribute('aria-hidden','true');
    box.innerHTML='<div class="sm-art-lightbox__stage"><img class="sm-art-lightbox__img" alt="Artwork enlarged view"></div><button class="sm-art-lightbox__close" type="button" aria-label="Close enlarged artwork"></button><button class="sm-art-lightbox__minus" type="button" aria-label="Zoom out">−</button><button class="sm-art-lightbox__plus" type="button" aria-label="Zoom in">+</button><div class="sm-art-lightbox__hint">PINCH OR TAP TO ZOOM • DRAG WHEN ZOOMED</div><div class="sm-art-lightbox__mark">STYLEMECHANICS</div><div class="sm-art-lightbox__counter">DETAIL VIEW</div>';
    document.body.appendChild(box);stage=box.querySelector('.sm-art-lightbox__stage');img=box.querySelector('.sm-art-lightbox__img');

    box.querySelector('.sm-art-lightbox__close').addEventListener('click',close);
    box.querySelector('.sm-art-lightbox__plus').addEventListener('click',function(e){e.stopPropagation();setScale(scale+.75)});
    box.querySelector('.sm-art-lightbox__minus').addEventListener('click',function(e){e.stopPropagation();setScale(scale-.75)});
    box.addEventListener('contextmenu',function(e){e.preventDefault()});
    box.addEventListener('dragstart',function(e){e.preventDefault()});

    stage.addEventListener('wheel',function(e){e.preventDefault();setScale(scale+(e.deltaY<0?.35:-.35),e.clientX,e.clientY)},{passive:false});
    stage.addEventListener('pointerdown',down);
    stage.addEventListener('pointermove',move);
    stage.addEventListener('pointerup',up);
    stage.addEventListener('pointercancel',up);

    stage.addEventListener('touchstart',onTouchStart,{passive:false});
    stage.addEventListener('touchmove',onTouchMove,{passive:false});
    stage.addEventListener('touchend',onTouchEnd,{passive:false});
    stage.addEventListener('touchcancel',onTouchEnd,{passive:false});

    stage.addEventListener('click',function(e){
      if(moved)return;
      var now=Date.now();
      if(now-lastTap<360){
        setScale(scale>1?1:2.6,e.clientX,e.clientY);
        lastTap=0;
      }else{
        lastTap=now;
        setTimeout(function(){
          if(lastTap===now){
            if(scale===1)setScale(2.2,e.clientX,e.clientY);
            else setScale(1);
            lastTap=0;
          }
        },220);
      }
    });

    document.addEventListener('keydown',function(e){
      if(!box||!box.classList.contains('is-open'))return;
      if(e.key==='Escape')close();
      if(e.key==='+')setScale(scale+.75);
      if(e.key==='-')setScale(scale-.75);
    });
  }
  function open(el){
    build();var s=srcFor(el);if(!s)return;
    img.src=s;img.alt=el.alt||'Artwork enlarged view';reset();
    box.classList.add('is-open');box.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';
  }
  function close(){
    if(!box)return;
    box.classList.remove('is-open','is-dragging');box.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';document.body.style.overflow='';
    pointers.clear();dragging=false;moved=false;touchDragging=false;touchPinchStart=0;
  }
  function dist(){var a=[].slice.call(pointers.values());if(a.length<2)return 0;var dx=a[0].x-a[1].x,dy=a[0].y-a[1].y;return Math.hypot(dx,dy)}
  function midpoint(){var a=[].slice.call(pointers.values());if(a.length<2)return null;return{x:(a[0].x+a[1].x)/2,y:(a[0].y+a[1].y)/2}}
  function down(e){
    if(!box.classList.contains('is-open'))return;
    if(e.pointerType==='touch')return;
    stage.setPointerCapture&&stage.setPointerCapture(e.pointerId);
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});moved=false;
    if(pointers.size===2){pinchStart=dist();pinchScale=scale;dragging=false;return}
    if(scale>1){dragging=true;box.classList.add('is-dragging');startX=e.clientX;startY=e.clientY;startTx=tx;startTy=ty}
  }
  function move(e){
    if(e.pointerType==='touch')return;
    if(!pointers.has(e.pointerId))return;
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(pointers.size===2){var d=dist(),m=midpoint();if(pinchStart&&m){setScale(pinchScale*(d/pinchStart),m.x,m.y);moved=true}return}
    if(dragging){var dx=e.clientX-startX,dy=e.clientY-startY;if(Math.abs(dx)>3||Math.abs(dy)>3)moved=true;tx=startTx+dx;ty=startTy+dy;draw()}
  }
  function up(e){
    if(e.pointerType==='touch')return;
    pointers.delete(e.pointerId);
    if(pointers.size<2){pinchStart=0;pinchScale=scale}
    if(pointers.size===0){dragging=false;box.classList.remove('is-dragging');setTimeout(function(){moved=false},50)}
  }
  function addTrigger(wrap,target){
    if(!wrap||wrap.querySelector(':scope > .sm-art-zoom-trigger'))return;
    wrap.classList.add('sm-has-art-zoom');
    var b=document.createElement('button');b.type='button';b.className='sm-art-zoom-trigger';
    b.setAttribute('aria-label','Zoom artwork');b.setAttribute('title','Click to magnify');
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();open(target)});wrap.appendChild(b);
  }
  function bindImageClick(el){
    if(el.dataset.smZoomBound)return;
    el.dataset.smZoomBound='1';el.classList.add('sm-art-zoomable');
    el.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();open(el)});
  }
  function scan(root){
    (root||document).querySelectorAll('img').forEach(function(el){
      if(!eligible(el))return;protect(el);
      if(graffiti(el)){var gw=el.closest('.smg5-frame,.smg5-card-img,.smg5-zoom-host');bindImageClick(el);addTrigger(gw,el);return}
      if(el.closest('#product-gallery'))bindImageClick(el);
      else if(el.closest('.product-thumb-img-wrap'))addTrigger(el.closest('.product-thumb-img-wrap'),el);
      else{var p=el.parentElement;if(p&&!p.closest('a,button')&&p.children.length<=3){p.classList.add('sm-art-zoom-host');addTrigger(p,el)}}
    });
  }
  document.addEventListener('contextmenu',function(e){var t=e.target;if(t&&t.matches&&t.matches('img.sm-art-protected'))e.preventDefault()},true);
  document.addEventListener('dragstart',function(e){var t=e.target;if(t&&t.matches&&t.matches('img.sm-art-protected'))e.preventDefault()},true);
  function init(){scan(document);var mo=new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1)scan(n)})})});mo.observe(document.body,{childList:true,subtree:true})}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();